import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-surface p-6 text-center" data-testid="payment-cancel-page">
      <img src="/assets/logo-full-sm.png" alt="BalkanHD Play" className="mb-2 h-24 w-24 object-contain" />
      <div className="fade-up flex flex-col items-center gap-3">
        <XCircle size={72} weight="fill" className="text-err" />
        <h1 className="mt-3 text-3xl font-bold" data-testid="payment-title">Uplata nije uspela</h1>
        <p className="max-w-[360px] text-sm leading-6 text-txt2" data-testid="payment-text">
          Plaćanje nije završeno i novac nije skinut sa vašeg računa. Možete pokušati ponovo u bilo kom trenutku.
        </p>
      </div>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link to="/activate-web" data-testid="cancel-retry" className="btn-primary">Pokušaj ponovo</Link>
        <Link to="/landing" data-testid="cancel-home" className="btn-ghost">Početna</Link>
      </div>
    </div>
  );
}
